import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {firestore} from "../../config/firebaseConfig";
import {FILTER_INITIAL_STATE, FILTER_STATUS_ALL} from "../../components/Po/constants";
import {STATUS_FAILED, STATUS_IDLE, STATUS_PENDING} from "../../constants";

export const searchPo = createAsyncThunk(
    'PO/search',
    async ({filter = FILTER_INITIAL_STATE, limit = 30}, thunkAPI) => {
        return new Promise(async (resolve, reject) => {
            try {
                const {snapShot, list, togoList} = thunkAPI.getState()?.po;
                const shouldLoadMore = snapShot.filter === filter;

                let queryRef = firestore.collection('purchase_orders').orderBy('PoRef', 'desc');
                let queryRefTogo = firestore.collection('purchase_orders').where("Currency", '==', "FCFA").orderBy('PoRef', 'desc');

                if (filter) {

                    if (filter.status && filter.status !== FILTER_STATUS_ALL)
                        queryRef = queryRef.where('ActivityStatus', '==', filter.status)

                    if (filter.date && filter.date.start)
                        queryRef = queryRef.where('CreateAt', '>=', filter.date.start)

                    if (filter.date && filter.date.end)
                        queryRef = queryRef.where('CreateAt', '<=', filter.date.end)

                    if (filter.delivery && filter.delivery.vendor)
                        queryRef = queryRef.where('VendorName', '==', filter.delivery.vendor.name)

                    if (filter.delivery && filter.delivery.location)
                        queryRef = queryRef.where('StoreName', '==', filter.delivery.location)

                    if (filter.user)
                        queryRef = queryRef.where('Username', '==', filter.user.name)

                }
                if (filter) {

                    if (filter.status && filter.status !== FILTER_STATUS_ALL)
                        queryRefTogo = queryRefTogo.where('ActivityStatus', '==', filter.status)

                    if (filter.date && filter.date.start)
                        queryRefTogo = queryRefTogo.where('CreateAt', '>=', filter.date.start)

                    if (filter.date && filter.date.end)
                        queryRefTogo = queryRefTogo.where('CreateAt', '<=', filter.date.end)

                    if (filter.delivery && filter.delivery.vendor)
                        queryRefTogo = queryRefTogo.where('VendorName', '==', filter.delivery.vendor.name)

                    if (filter.delivery && filter.delivery.location)
                        queryRefTogo = queryRefTogo.where('StoreName', '==', filter.delivery.location)

                    if (filter.user)
                        queryRefTogo = queryRefTogo.where('Username', '==', filter.user.name)

                }

                if (shouldLoadMore && snapShot.cursor)
                    queryRef = queryRef.startAfter(snapShot.cursor)

                if (shouldLoadMore && snapShot.cursor)
                    queryRefTogo = queryRefTogo.startAfter(snapShot.cursor)

                const docSnap = await queryRef.limit(limit).get();
                const docSnapTogo = await queryRefTogo.limit(limit).get();

                const result = docSnap.docs.map(doc => ({id: doc.id, ...doc.data()}))?.filter(e => (e.Currency === 'DOLLAR' || e.Currency === null) ); 
                const resultTogo = docSnapTogo.docs.map(doc => ({id: doc.id, ...doc.data()})); 
 
                resolve({
                    list: (shouldLoadMore && list) ? [...list, ...result] : [...result],
                    togoList: (shouldLoadMore && togoList) ? [...togoList, ...resultTogo] : [...resultTogo],
                    noResult: (result.length === 0),
                    snapShot: {
                        filter: filter,
                        cursor: docSnap.docs[docSnap.docs.length - 1]
                    }
                });
            } catch (e) {
                console.log(e)
                reject(e)
            }
        })
    }
)


export const updatePoStatus = createAsyncThunk(
    'PO/update_status',
    async ({data, onResolve}) => {
        try {
            await firestore.collection('purchase_orders').doc(data.id).update(data);
            onResolve && onResolve('done')
        } catch (e) {
            console.log(e)
            onResolve && onResolve('failed')
        }

    }
)
const purchasingOrdersSlice = createSlice({
    name: 'PO',
    initialState: {
        list: null,
        togoList: null,
        status: STATUS_IDLE,
        noResult: false,
        snapShot: {
            filter: null,
            cursor: null
        }
    },
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(searchPo.pending, state => {
                state.status = STATUS_PENDING;
                state.noResult = false;
            })
            .addCase(searchPo.rejected, state => {
                state.status = STATUS_FAILED;
            })
            .addCase(searchPo.fulfilled, (state, action) => {
                state.status = STATUS_IDLE;
                state.list = action.payload.list; 
                state.togoList = action.payload.togoList; 
                state.noResult = action.payload.noResult;
                state.snapShot = action.payload.snapShot;
            })
    }
})

export const selectPo = state => state.po;

export default purchasingOrdersSlice.reducer;

